import script from "./AppBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__